<script setup>
import { ref, onMounted, defineExpose } from 'vue';

const name = ref('xxxx');

onMounted(() => {
  setTimeout(() => {
    name.value = 'jackson';
  }, 2000);
});

defineExpose({
  happyName: name,
});
</script>
<template>
  <div>Inner Setup</div>
</template>
